import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProjectsContext } from 'src/app/providers/ProjectProvider';
import { TableContext } from 'src/app/providers/TableProvider';
import ProjectsService from 'src/shared/api/projects/ProjectsService';
import { routesEnum } from 'src/shared/const';
import { setError } from 'src/shared/lib/utils';
import { FormType, ProjectType } from 'src/shared/store/projects/types';

type SelectProjectOptions = {
  keepAliasRoute?: boolean;
  ensureFormsLoaded?: boolean;
};

export const useGetFormsList = () => {
  const navigate = useNavigate();
  const { forms, setForms, setIsFormsLoading, selectedProject, setSelectedProject } =
    useContext(ProjectsContext);
  const { setSelectedForm, setTableSettings } = useContext(ProjectsContext);
  const { setTableData, resetTable } = useContext(TableContext);

  const loadProjectForms = useCallback(
    async (projectId: number): Promise<FormType[]> => {
      setIsFormsLoading(true);

      try {
        const { data } = await ProjectsService.getFormsByProjectId({ projectId });
        const formsList = data || [];
        setForms(formsList);
        return formsList;
      } catch (e) {
        setError(e.response?.data?.error || 'РћС€РёР±РєР° Р·Р°РіСЂСѓР·РєРё РїСЂРѕРµРєС‚Р°');
        return [];
      } finally {
        setIsFormsLoading(false);
      }
    },
    [setForms, setIsFormsLoading],
  );

  const handleSelectProject = useCallback(
    async (project: ProjectType, options?: SelectProjectOptions): Promise<FormType[]> => {
      if (project.id === selectedProject?.id) {
        if (options?.ensureFormsLoaded) {
          if (forms.length) {
            return forms;
          }

          return loadProjectForms(project.id);
        }

        resetTable();
        return [];
      }

      setSelectedForm(null);
      setTableSettings(null);
      setTableData([]);
      setSelectedProject(project);

      const formsList = await loadProjectForms(project.id);

      if (!options?.keepAliasRoute) {
        navigate(routesEnum.TABLE);
      }

      return formsList;
    },
    [
      forms,
      loadProjectForms,
      navigate,
      resetTable,
      selectedProject?.id,
      setSelectedForm,
      setSelectedProject,
      setTableData,
      setTableSettings,
    ],
  );

  return { handleSelectProject };
};
